import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'connected-react-router';

import {
  submitAnswers
} from 'actions';
import normalizeFullWidthChars from 'common/App/normalizeFullWidthChars';

import { BlankQuestionnaire } from 'components/Questionnaire/BlankQuestionnaire';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

const countriesList = ['United States of America', 'Canada', 'United Kingdom', 'Afghanistan', 'Aland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia',
  'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil',
  'British Virgin Islands', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China',
  'Hong Kong, SAR China', 'Macao, SAR China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo (Brazzaville)', 'Congo, (Kinshasa)', 'Cook Islands', 'Costa Rica', 'Côte d&amp;Ivoire', 'Croatia', 'Cuba',
  'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji',
  'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and Mcdonald Islands',
  'Holy See (Vatican City State)', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya',
  'Kiribati', 'Korea (North)', 'Korea (South)', 'Kuwait', 'Kyrgyzstan', 'Lao PDR', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia, Republic of', 'Madagascar', 'Malawi', 'Malaysia',
  'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique',
  'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau',
  'Palestinian Territory', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint-Barthélemy', 'Saint Helena',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint-Martin (French part)', 'Saint Pierre and Miquelon', 'Saint Vincent and Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen Islands',
  'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic (Syria)', 'Taiwan, Republic of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia',
  'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'US Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela (Bolivarian Republic)', 'Viet Nam',
  'Virgin Islands, US', 'Wallis and Futuna Islands', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'
];

class QuestionnaireContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape().isRequired,
    isSubmittingAnswers: PropTypes.bool,
    redirectUrl: PropTypes.string
  };

  static defaultProps = {
    isSubmittingAnswers: false,
    redirectUrl: ''
  };

  static getW9Questions() {
    return [{
      question: 'Do you own a US Passport?',
      fieldName: 'usPassport',
      fieldType: 'YesNo'
    },
    {
      question: 'Do you live in the USA?',
      fieldName: 'usResident',
      fieldType: 'YesNo'
    },
    {
      question: 'Please select all countries where you are resident for tax purposes.',
      fieldName: 'taxResidency',
      fieldType: 'Select-Multiple',
      lines: 10,
      options: countriesList },
    {
      fieldType: 'TIN'
    }];
  }

  static getBeneQuestions() {
    return [{
      question: 'Is the entity a US resident for the purposes of taxation?',
      fieldName: 'usResident',
      fieldType: 'YesNo'
    },
    {
      question: 'Does the entity have a current US residence address or US mailing address?',
      fieldName: 'usEntityResidentAddress',
      fieldType: 'YesNo'
    },
    {
      question: 'Does the entity have standing instructions to pay amounts to a US address or an account maintained in the US?',
      fieldName: 'instructionsToPaytoUsAddress',
      fieldType: 'YesNo'
    },
    {
      question: 'Does the entity have a current telephone number for the entity in the US?',
      fieldName: 'usTelephoneNumber',
      fieldType: 'YesNo'
    },
    {
      question: 'Does the entity have a power of attorney or signatory authority granted to a person with a US address?',
      fieldName: 'usPowerOfAttorney',
      fieldType: 'YesNo'
    },
    {
      question: 'Are you a Financial Institution?',
      fieldName: 'financialInstitution',
      fieldType: 'YesNo'
    },
    {
      question: 'Please provide you GIIN number (if any)',
      fieldName: 'giin',
      fieldType: 'Text'
    },
    {
      question: 'Please select all countries where the entity is resident for tax purposes.',
      fieldName: 'taxResidency',
      fieldType: 'Select-Multiple',
      lines: 10,
      options: countriesList
    },
    {
      fieldType: 'TIN'
    },
    {
      question: 'Are you also going to be transacting business which is effectively connected with the conduct of a trade or business in the United States?',
      fieldName: 'transactingBusinessInUs',
      fieldType: 'YesNo'
    }];
  }

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    const { match } = this.props;
    const { params: { id } } = match;
    this.state = {
      id
    };
  }

  componentDidUpdate(prevProps) {
    const { dispatch, redirectUrl } = this.props;

    if (redirectUrl && !prevProps.redirectUrl) {
      dispatch(push(redirectUrl));
    }
  }

  handleSubmit(values) {
    const { dispatch } = this.props;
    const { id } = this.state;

    const formType = (id === '2') ? 'w8bene_2021' : 'w9_2018';

    const normalizedValues = {
      ...values,
      accountHolderTaxInfo: values.accountHolderTaxInfo
        ? values.accountHolderTaxInfo.map(entry => ({
          ...entry,
          taxIdNumber: normalizeFullWidthChars(entry.taxIdNumber)
        }))
        : values.accountHolderTaxInfo
    };

    dispatch(submitAnswers({ id, formType, questionnaire: normalizedValues }));
  }

  render() {
    const { isSubmittingAnswers } = this.props;
    const { id } = this.state;

    return (
      <div className="questionnaire">
        <BlankQuestionnaire
          title={ `FATCA & CRS Questionnaire - ${ id === '2' ? 'Entity' : 'Individual' }` }
          isSubmittingAnswers={ isSubmittingAnswers }
          onSubmit={ e => this.handleSubmit(e) }
          questionSet={ id === '2' ? QuestionnaireContainer.getBeneQuestions() : QuestionnaireContainer.getW9Questions() }
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    questionnaire: {
      isSubmittingAnswers,
      redirectUrl
    }
  } = state;

  return {
    isSubmittingAnswers,
    redirectUrl
  };
}

export default withRouter(connect(
  mapStateToProps
)(withContainerErrorBoundary(QuestionnaireContainer, 'Questionnaire')));
